import type { ControlCenterJob } from '../types/controlCenter'
import { normalizeLatLng } from './geoCoordinates'

/**
 * Map a `jobtread.listJobsWithLocations` row to a Control Center job entity.
 * Returns null if lat/lng are missing or invalid.
 */
export function mapJobtreadJobRow(row: Record<string, unknown>): ControlCenterJob | null {
  const geo = normalizeLatLng(row.lat, row.lng)
  if (!geo) return null

  const id = String(row.id ?? '').trim()
  if (!id) return null

  const closedOn =
    row.closedOn != null && String(row.closedOn).trim() ? String(row.closedOn) : null
  const active =
    typeof row.active === 'boolean' ? row.active : closedOn == null

  return {
    id,
    name: String(row.name || '').trim() || 'Untitled job',
    number: row.number != null ? String(row.number).trim() : '',
    status: row.status != null ? String(row.status).trim() : '',
    closedOn,
    active,
    projectType: row.projectType != null ? String(row.projectType).trim() : '',
    locationId: String(row.locationId || '').trim(),
    locationName: String(row.locationName || '').trim(),
    address: String(row.address || '').trim(),
    state: String(row.state || '').trim().toUpperCase(),
    city: String(row.city || '').trim(),
    accountName: String(row.accountName || '').trim(),
    lat: geo.lat,
    lng: geo.lng,
    scheduleStart:
      row.scheduleStart != null && String(row.scheduleStart).trim()
        ? String(row.scheduleStart).trim().slice(0, 10)
        : null,
    scheduleEnd:
      row.scheduleEnd != null && String(row.scheduleEnd).trim()
        ? String(row.scheduleEnd).trim().slice(0, 10)
        : null,
  }
}
